<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalLabel }}</div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal mainInputDiv">
    <form [formGroup]="productProjectForm" (keydown.enter)="$event.preventDefault()">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required">
            <piqet-angular-common-input
              formControlName="productName"
              [control]="productProjectForm.get('productName')"
              label="Product name"
              placeholder="Product name"
              [maxLength]="50"
              [submitted]="submitted"
              [preventDot]="true"
            >
            </piqet-angular-common-input>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group">
          <div class="services-form">
            <textarea
              formControlName="description"
              cols="20"
              id="Description"
              name="Description"
              rows="2"
              placeholder="Description"
            ></textarea>
            <label>Description</label>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 form-group">
          <piqet-angular-file-upload
            type="image"
            [customConfig]="{
              selectButtonText: 'Select file',
              changeButtonText: 'Change',
              removeButtonText: 'Remove',
              placeholderText: 'Project image',
              acceptedFileTypes: ['image/png', 'image/jpg', 'image/jpeg', 'image/gif'],
              acceptAttribute: '.png,.jpg,.jpeg,.gif',
              maxFileSize: 5,
              showPreview: false,
              customErrorMessage: 'Only .jpg,.png,.jpeg,.gif file allowed'
            }"
            [existingFileUrl]="existingImageUrl"
            [existingFileName]="existingFileName"
            (fileSelected)="onFileSelected($event)"
            (removeConfirmation)="onRemoveImage()"
            #fileUploadComponent
          >
          </piqet-angular-file-upload>
        </div>
      </div>
      <div class="row" *ngIf="!this.productProjectData.productConfigId">
        <label class="countryLable">{{ projectsPlaceholder.PROCESS_COUNTRY_LABEL }}</label>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="form-group countryDropDown">
            <ng-select
              [clearable]="false"
              #country
              [items]="defaultRegionItems"
              [searchable]="false"
              bindLabel="name"
              formControlName="country"
              [searchFn]="commonInputSearch"
              (change)="defalutCountry($event)"
              [ngClass]="
                productProjectForm.controls['country'].value?.length > 11 ? 'multi-select' : ''
              "
              [multiple]="true"
              [placeholder]="projectsPlaceholder.PROCESS_COUNTRY"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    placeholder="Search..."
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="country.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
      <div class="row">
        <label class="countryLable">{{ projectsPlaceholder.DEFAULT_COUNTRY_LABEL }}</label>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="form-group required">
            <ng-select
              [clearable]="false"
              [clearOnBackspace]="false"
              #defaultCountry
              [items]="selectCountry || defaultRegionItems"
              [searchable]="false"
              bindLabel="name"
              formControlName="defaultCountry"
              [searchFn]="commonInputSearch"
              [placeholder]="projectsPlaceholder.DEFAULT_COUNTRY"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    placeholder="Search..."
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="defaultCountry.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (productProjectForm.controls['defaultCountry']?.touched &&
                  productProjectForm.controls['defaultCountry']?.invalid) ||
                (submitted && !productProjectForm.controls['defaultCountry'].value?.name)
              "
              class="input-error"
            >
              Country is required
            </div>
          </div>
        </div>
      </div>

      <div class="row pb-3">
        <div class="col-sm-4">
          <div class="d-flex w-100 justify-content-between align-items-center checkboxview">
            <div class="d-flex checkBoxAlienMent">
              <div>
                <input
                  type="checkbox"
                  class="chkOverview"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="isCostTurnedOff"
                  (change)="costTurnOff($event)"
                />
              </div>
              <div><span class="checkbox-style switch-cost">Switch on cost</span></div>
            </div>
          </div>
        </div>
      </div>

      <div class="row pb-3" *ngIf="showCurrencyList">
        <div class="col-sm-6 currencyTab">
          <div class="project-spacing currency-drpdown">
            <label class="labelColor">Currency</label>
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #currency
              [items]="currencyList"
              (change)="selectCurrency($event)"
              [searchable]="false"
              bindLabel="name"
              placeholder="Currency"
              formControlName="currency"
              [searchFn]="commonInputSearch"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="currency.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>

      <div class="row">
        <div>
          <div class="input-div">
            <label class="labelColor">Unit *</label>
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #unit
              [items]="unitList"
              formControlName="unit"
              [searchable]="false"
              placeholder="Unit"
              bindLabel="name"
              (change)="changeUnit($event)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="unit.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
          <div
            *ngIf="
              (submitted || productProjectForm.controls['unit']?.touched) &&
              productProjectForm.controls['unit']?.invalid
            "
            class="input-error"
          >
            Unit is required.
          </div>
        </div>
      </div>

      <div class="setButtonAndError text-margin">
        <div class="modal-footer">
          <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
          <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">
            Save
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
